import 'dotenv/config';
import { API } from './api/API';
import { LoggingService } from './services/LoggingService';

type MNOHSEnvironment = {
  /** The current API. */
  api: API;
  /** Config aka environment variables */
  config: {
    authDomain: string;
    authClientId: string;
  };
  /** Currently available services. */
  services: {
    logger: LoggingService;
  };
};

/** This value holds the actual environment object. */
let _currentEnvironment: MNOHSEnvironment | undefined = undefined;

/** Exposes the current `MNOHSEnvironment` via `current()`. */
const Environment = {
  /** Returns the current environment. */
  current(): MNOHSEnvironment {
    return { ..._currentEnvironment! };
  },

  /**
   * Sets the current environment. Call as early as possible during startup, and
   * ONLY call once.
   */
  set(environment: MNOHSEnvironment) {
    if (_currentEnvironment === undefined) {
      _currentEnvironment = environment;
    }
  },
};

Object.freeze(Environment);
export { Environment };
